import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";
import { Clock, Sparkle } from "@phosphor-icons/react";

function diffString(ts) {
  if (!ts) return null;
  const end = new Date(ts).getTime();
  const ms = end - Date.now();
  if (ms <= 0) return null;
  const totalHours = Math.floor(ms / 3_600_000);
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  if (days >= 1) return `${days} day${days === 1 ? "" : "s"}, ${hours}h`;
  const mins = Math.floor((ms % 3_600_000) / 60_000);
  return `${hours}h ${mins}m`;
}

/**
 * Trial countdown banner. We DON'T set up a setInterval here — the value
 * recomputes on every render of the Dashboard (which happens frequently
 * enough). This keeps the component pure and analyzer-friendly.
 */
export default function TrialBanner() {
  const { user } = useAuth();
  if (!user?.is_trial || !user?.trial_ends_at) return null;
  const remaining = diffString(user.trial_ends_at);
  if (!remaining) return null;

  return (
    <div data-testid="trial-banner"
      className="mb-6 relative overflow-hidden bg-gradient-to-r from-blue-600/15 via-blue-500/10 to-transparent border border-blue-500/30 rounded-xl px-5 py-3 flex flex-wrap items-center gap-3"
    >
      <Sparkle size={16} weight="fill" className="text-blue-400" />
      <div className="text-sm flex-1">
        <span className="text-white font-medium">Pro trial active.</span>
        <span className="text-zinc-400"> Your Pro trial is active for the next </span>
        <span className="text-blue-300 font-mono" data-testid="trial-remaining">{remaining}</span>
        <span className="text-zinc-400">. Your authorized payment method will be charged the normal Pro subscription price when the trial ends unless you cancel first.</span>
      </div>
      <Link to="/pricing" data-testid="trial-upgrade-btn"
        className="text-xs bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-md inline-flex items-center gap-1.5">
        <Clock size={12} /> Manage trial
      </Link>
    </div>
  );
}
